module.exports = __webpack_public_path__ + "img/reg_done.1bb48a14.png";